module.exports = __webpack_public_path__ + "static/media/finance-icon-selected.e11acfd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/finance-icon-selected.svg
// module id = 1924
// module chunks = 0